var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketingList" }, [
    _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("拼团策略")]),
    _c(
      "div",
      { staticClass: "marketingList_main clear relative b_white f14" },
      [
        _c("div", { staticClass: "clear" }, [
          _c("span", { staticClass: " pull-left gray_2 f14" }, [
            _vm._v("拼团活动列表")
          ]),
          _c(
            "div",
            { staticClass: " pull-right clear" },
            [
              _c(
                "el-button",
                {
                  staticClass: "f16",
                  attrs: { type: "primary" },
                  on: { click: _vm.toAddActivity }
                },
                [
                  _c("span", { staticClass: "f22 lin_25" }, [_vm._v("+")]),
                  _vm._v(" 添加拼团活动")
                ]
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "box30" }),
        _c("div", { staticClass: "marketing_table f14 t_center" }, [
          _c("div", { staticClass: "table_main" }, [
            _vm._m(0),
            _c(
              "table",
              { attrs: { cellpadding: "0", cellspacing: "0", border: "0" } },
              [
                _c(
                  "tbody",
                  _vm._l(_vm.activityList, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", { attrs: { width: "200" } }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _c("td", { attrs: { width: "140" } }, [
                        _vm._v(_vm._s(item.startTimeStr))
                      ]),
                      _c("td", { attrs: { width: "140" } }, [
                        _vm._v(_vm._s(item.endTimeStr))
                      ]),
                      _c("td", { attrs: { width: "80" } }, [
                        _vm._v(
                          _vm._s(
                            item.activityStatus == 1
                              ? "未开始"
                              : item.activityStatus == 2
                              ? "活动中"
                              : "活动结束"
                          )
                        )
                      ]),
                      _c(
                        "td",
                        { attrs: { width: "" } },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getActivityDetail(item)
                                }
                              }
                            },
                            [_vm._v("查看")]
                          ),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.copyLinks(item)
                                }
                              }
                            },
                            [_vm._v("复制链接")]
                          ),
                          item.activityStatus !== 2
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.delActivity(item)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                          item.activityStatus !== 2
                            ? _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.updateActivity(item)
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ]),
          _c("div", { staticClass: "box30" }),
          _c(
            "div",
            { staticClass: "pages text-right" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pagination.currentPage,
                  "page-sizes": [10, 20, 30],
                  "page-size": _vm.pagination.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.pagination.totalCount
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticClass: "marketing_table_head",
        attrs: { cellpadding: "0", cellspacing: "0" }
      },
      [
        _c("thead", [
          _c("tr", [
            _c("td", { attrs: { width: "200" } }, [_vm._v("活动名称")]),
            _c("td", { attrs: { width: "140" } }, [_vm._v("开始时间")]),
            _c("td", { attrs: { width: "140" } }, [_vm._v("结束时间")]),
            _c("td", { attrs: { width: "80" } }, [_vm._v("状态")]),
            _c("td", { staticClass: "text-center", attrs: { width: "" } }, [
              _c("span", [_vm._v("操作")])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }